import { useContext } from 'react'
import { AppError } from '@jotta/types/AppError'
import { getBrandName } from '@jotta/types/Brand'
import { BrandContext } from '../Brand/BrandProvider/BrandProvider'
import { getbrandStore } from '../Brand/BrandStore/BrandStore'
import config from '@jotta/config/BrandConfig'

export function useBrandTheme() {
  const { theme } = useBrandContext()
  const brandCode = theme.branding.brand
  return {
    theme,
    brandCode,
    brandStore: getbrandStore(theme),
    brandName: getBrandName(brandCode),
  }
}

export function useBrandContext() {
  const brandContext = useContext(BrandContext)
  if (!brandContext) {
    throw new AppError({
      message: 'useBrandTheme must be used inside BrandContextProvider',
    })
  }
  return brandContext
}

export function useBrandStore() {
  const { theme } = useBrandContext()
  return getbrandStore(theme)
}

export function useBrandCode() {
  const { theme } = useBrandContext()
  return theme.branding.brand
}

export function useBrandConfig() {
  const brandCode = useBrandCode()
  return config[brandCode]
}
